import config from '../../config/config';

const B_URL = `${config.API_BASE_URL}/api/`;
export const variables = {
    BASE_URL: B_URL,
    EMAIL_API: `${B_URL}Email`,
    EMAIL_ADMIN_API: `${B_URL}User`,
    USER_API: `${B_URL}Customers`,
    ADMIN_API: `${B_URL}Admin`,
    PRODUCT_API: `${B_URL}Kits`,
    STOCKITEM_API: `${B_URL}Items`,
    INVOICE_API: `${B_URL}OpenARInvoices`,
    CART_API: `${B_URL}Carts`,
    ORDER_API: `${B_URL}Order`,
    PRODUCTSIZE_API: `${B_URL}productsize`,
    ORDERITEM_API: `${B_URL}orderitem`,
    YEARLY_WORKSCHEDULE_API: `${B_URL}YearlyWorkSchedule`,
    CATEGORY_API: `${B_URL}Category`,
    PAYMENT_API: `${B_URL}Payment`,
    BRAND_API:`${B_URL}brands`,
    PAID_INVOICE_API:`${B_URL}PaidInvoices`,
    FACILITYS_API:`${B_URL}Facilitys`,
    MAINTENANCE_API:`${B_URL}maintenance`,
    FEEDBACK_API:`${B_URL}Feedback`,
    IMAGECACHE:`${B_URL}ImageCache`,
};